(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GoalsCounter = exports["default"] = /*#__PURE__*/function () {
  /**
   * @param {String} ymCounterKey
   * @param {Object} options
   */
  function GoalsCounter(ymCounterKey) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, GoalsCounter);
    this.ymCounterKey = null;
    this.options = this._mergeOptions(options);
    if (ymCounterKey) {
      this.ymCounterKey = ymCounterKey;
    } else {
      this._findYmCounter(this.options.iterations);
    }
  }

  /**
   * Overrides default settings with custom ones.
   *
   * @param {Object} options
   *
   * @return {Object}
   */
  return _createClass(GoalsCounter, [{
    key: "_mergeOptions",
    value: function _mergeOptions(options) {
      var settings = {
        iterations: 10,
        timeout: 300
      };
      Object.keys(options).forEach(function (key) {
        settings[key] = options[key];
      });
      return settings;
    }

    /**
     * @param {Number} i — The number of attempts to find the yaCounter value.
     *
     * @private
     */
  }, {
    key: "_findYmCounter",
    value: function _findYmCounter(i) {
      var _this = this;
      var yaCounter = Object.keys(window).filter(function (el) {
        return /^yaCounter.*?/i.test(el);
      });
      if (!yaCounter.length) {
        i--;
        setTimeout(function () {
          return _this._findYmCounter(i);
        }, this.options.timeout);
      } else {
        this.ymCounterKey = yaCounter;
      }
    }
  }, {
    key: "sendGoals",
    value: function sendGoals(ymGoal, gaGoal, fbGoal) {
      if (ymGoal && this.ymCounterKey && window[this.ymCounterKey]) {
        window[this.ymCounterKey].reachGoal(ymGoal);
      }
      if (gaGoal && typeof ga === 'function') {
        ga('send', 'event', gaGoal.category, gaGoal.action, gaGoal.label);
      }
      if (typeof fbq !== 'undefined' && fbGoal) {
        fbq('track', fbGoal);
      }
    }
  }]);
}();

},{}],2:[function(require,module,exports){
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

},{}],3:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  "use strict";

  require("./app/polyfills");
  require("./app/all");
  require("./app/scrollbar");
  require("./app/aside-nav");
  require("./app/modal");
  require("./app/form");
  require("./app/inputs");
  require("./app/tooltip");
  require("./app/feature");
  require("./app/video");
  require("./app/menu");
  require("./app/vertical-tabs");
  require("./app/glossary");
  require("./app/filter");
  require("./app/filter-select");
  require("./app/expand");
  require("./app/cookies");
  require("./app/tabs");
  require("./app/fancybox-init");
  require("./app/accordion");
  require("./app/marketplace");
  require("./app/load-more");
  require("./app/lang-switcher");
  require("./app/slider");
})(window, document, jQuery);

},{"./app/accordion":4,"./app/all":5,"./app/aside-nav":6,"./app/cookies":7,"./app/expand":8,"./app/fancybox-init":9,"./app/feature":10,"./app/filter":12,"./app/filter-select":11,"./app/form":13,"./app/glossary":15,"./app/inputs":16,"./app/lang-switcher":17,"./app/load-more":18,"./app/marketplace":19,"./app/menu":20,"./app/modal":21,"./app/polyfills":22,"./app/scrollbar":23,"./app/slider":24,"./app/tabs":25,"./app/tooltip":26,"./app/vertical-tabs":27,"./app/video":28}],4:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Accordion = /*#__PURE__*/function () {
  function Accordion(menu, isMultiple) {
    _classCallCheck(this, Accordion);
    if (menu) {
      this.menu = menu;
      this.isMultiple = isMultiple;
      this.init();
    }
  }
  return _createClass(Accordion, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.dropdownItems = this.menu.querySelectorAll('[data-toggle="accordion-item"]');
      this.dropdownItems.forEach(function (item) {
        item.children[0].addEventListener('click', function (e) {
          _this.dropdown(e, _this.isMultiple);
        });
      });
      this.activeDropdownItems = this.menu.querySelectorAll('[data-toggle="accordion-item"].active');
      this.activeDropdownItems.forEach(function (item) {
        item.children[1].style.height = item.children[1].offsetHeight + 'px';
      });
    }
  }, {
    key: "dropdown",
    value: function dropdown(e, isMultiple) {
      var dropdownLink = e.target;
      var dropdownItem = dropdownLink.parentElement;
      var dropdownMenu = dropdownLink.nextElementSibling;
      if (!dropdownItem.classList.contains('active')) {
        dropdownItem.classList.add('active');
        dropdownMenu.removeAttribute('style');
        var height = dropdownMenu.offsetHeight;
        dropdownMenu.style.height = '0px';
        setTimeout(function () {
          dropdownMenu.style.height = height + 'px';
        }, 0);
      } else {
        setTimeout(function () {
          dropdownMenu.style.height = '0px';
        }, 0);
        dropdownMenu.addEventListener('transitionend', this.onMenuTransitionend, {
          once: true
        });
      }
      if (!isMultiple) {
        var activeElements = dropdownItem.parentElement.querySelectorAll('[data-toggle="accordion-item"].active');
        activeElements.forEach(function (item) {
          if (item !== dropdownItem) {
            item.classList.remove('active');
          }
        });
      }
    }
  }, {
    key: "onMenuTransitionend",
    value: function onMenuTransitionend(e) {
      var eParent = e.target.parentElement;
      var eParentPrevious = eParent.previousElement;
      var eParentNext = eParent.nextElement;
      eParent.classList.remove('active');
      eParent.classList.remove('no-before');
      eParent.classList.remove('no-after');
      if (eParentPrevious && eParentPrevious.classList.contains('active')) {
        eParentPrevious.classList.remove('no-before');
      }
      if (eParentNext && eParentNext.classList.contains('active')) {
        eParentNext.classList.remove('no-after');
      }
    }
  }]);
}();
var expandMenu = document.querySelector('[data-type="accordion"]');
if (expandMenu) {
  new Accordion(expandMenu, true);
}

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lang = exports.isMobileDevice = void 0;
if (/Android/.test(navigator.appVersion)) {
  window.addEventListener("resize", function () {
    if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
      document.activeElement.scrollIntoView();
    }
  });
}
$('input, textarea').each(function (e) {
  if ($(this).val() != '') {
    $(this).addClass('not-empty');
  } else {
    $(this).removeClass('not-empty');
  }
});
$('input, textarea').on('change focusout keydown', function () {
  if ($(this).val() != '') {
    $(this).addClass('not-empty');
  } else {
    $(this).removeClass('not-empty');
  }
});
$('input, textarea').on('focusin', function () {
  $(this).parent().addClass('focused');
});
$('input, textarea').on('focusout', function () {
  $(this).parent().removeClass('focused');
});
var lang = exports.lang = document.querySelector('html').lang;
$.validator.messages.required = lang === 'ru' ? "Это поле обязательное" : "This field is required";
var thanksContruction = '<div class="form-thanks-message">' + '<div class="top-main">Спасибо, ваша заявка принята!</div>' + '<div class="message">В&nbsp;ближайшее время с&nbsp;вами свяжется наш менеджер.</div>' + '</div>';
var headerFixedHeight = 50;
$(window).on('scroll load resize', function () {
  if ($(this).scrollTop() > headerFixedHeight && !$('body').hasClass("scrolled")) {
    $('body').addClass("scrolled");
  } else if ($(this).scrollTop() <= headerFixedHeight && $('body').hasClass("scrolled")) {
    $('body').removeClass("scrolled");
  }
});
$('[data-toggle="menu-anchor"]').click(function (e) {
  e.preventDefault();
  var target = $(this).data('target');
  smoothScrolling(target);
});
$('.header-link').click(function (e) {
  smoothScrolling(target);
});
if (anchorTarget) {
  setTimeout(function () {
    smoothScrolling(anchorTarget);
  }, 300);
}
function smoothScrolling(target) {
  var top = $(target).offset().top - 150;
  $('html,body').animate({
    scrollTop: top
  }, 500);
}
$('#blog__more').on('click', function (e) {
  var $btnMore = $(this);
  e.preventDefault();
  $.post('/wp-admin/admin-ajax.php', {
    'action': 'load_more'
  }, function (response) {
    response = JSON.parse(response);
    if (response.status === 'end') {
      $btnMore.addClass('disabled');
    }
    if (response['template'] !== '') {
      $('.blog-row').append(response['template']);
    }
  });
});
var isMobileDevice = exports.isMobileDevice = function isMobileDevice() {
  return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf('IEMobile') !== -1;
};
if (isMobileDevice()) {
  document.body.classList.add('touch-device');
}

},{}],6:[function(require,module,exports){
"use strict";

var _scrollTo = _interopRequireDefault(require("../modules/scrollTo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var aside_nav = document.querySelector('.aside-menu');
if (aside_nav) {
  var items = document.querySelectorAll('.aside-menu__item .aside-menu__link');
  var headers = document.querySelectorAll('.blog-content--main-content h2, .blog-content--main-content h3');
  var getCurrentHeader = function getCurrentHeader(scroll) {
    var headerArr = Array.from(headers);
    for (var i = 1; i <= headerArr.length; i++) {
      var arrPosition = headerArr.length - i;
      var headerPosition = headers[arrPosition].getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop) - window.outerHeight / 2;
      if (scroll >= headerPosition) return headers[arrPosition].id;
    }
  };
  var setActiveItem = function setActiveItem(id) {
    items.forEach(function (item) {
      return item.classList[item.dataset.target === id ? 'add' : 'remove']('active');
    });
  };
  window.addEventListener('scroll', function () {
    var currentScroll = window.scrollY || document.documentElement.scrollTop;
    var id = getCurrentHeader(currentScroll);
    setActiveItem(id);
  });
  items.forEach(function (item) {
    item.addEventListener('click', function () {
      (0, _scrollTo["default"])(document.getElementById(item.dataset.target), 1000);
    });
  });
}

},{"../modules/scrollTo":33}],7:[function(require,module,exports){
"use strict";

var $cookies = $('.cookies');
if ($cookies.length) {
  $cookies.css('display', 'block').animate({
    bottom: 0
  }, 200);
  $('.cookies__close').on('click', function () {
    Cookies.set('smplCookies', 'accepted');
    $cookies.animate({
      bottom: -70 + 'px'
    }, 200);
    setTimeout(function () {
      $cookies.remove();
    }, 200);
  });
}

},{}],8:[function(require,module,exports){
"use strict";

var expandElem = document.querySelectorAll('[data-toggle="expand"]');
if (expandElem.length) {
  expandElem.forEach(function (item, e) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      item.parentNode.classList.toggle('active');
      item.nextElementSibling.classList.toggle('show');
    });
  });
}

},{}],9:[function(require,module,exports){
"use strict";

$('[data-fancybox]').fancybox({
  arrows: true,
  infobar: true,
  buttons: ["close"],
  btnTpl: {
    close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="Закрыть">' + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg>' + "</button>",
    arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="Предыдущее">' + '<div>' + '<svg xmlns="http://www.w3.org/2000/svg" width="11.536" height="19.535" viewBox="0 0 11.536 19.535">' + '    <g id="prefix__Group_26049" data-name="Group 26049" transform="translate(1.768 1.768)">' + '        <path id="prefix___" d="M238.8 368.7l-8 8 8 8" data-name="&gt;" transform="translate(-230.8 -368.7)" style="fill:none;stroke:#96aac1;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2.5px"/>' + '    </g>' + '</svg>' + '</div>' + "</button>",
    arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="Следующее">' + '<div>' + '<svg xmlns="http://www.w3.org/2000/svg" width="11.536" height="19.535" viewBox="0 0 11.536 19.535">' + '    <g id="prefix__Group_26049" data-name="Group 26049" transform="translate(1.768 1.768)">' + '        <path id="prefix___" d="M238.8 368.7l-8 8 8 8" data-name="&gt;" transform="translate(-230.8 -368.7)" style="fill:none;stroke:#96aac1;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2.5px"/>' + '    </g>' + '</svg>' + '</div>' + "</button>"
  }
});

},{}],10:[function(require,module,exports){
"use strict";

var objParents = document.querySelectorAll('.object-parent');
if (objParents.length > 0) {
  var getContent = function getContent(item) {
    var object = item.querySelector("object");
    var objectContent = object.contentDocument;
    return objectContent.querySelectorAll("g, path, rect");
  };
  var setFill = function setFill(item) {
    getContent(item).forEach(function (svgItem) {
      var attr = svgItem.getAttribute('fill');
      if (attr === '#921e40') {
        svgItem.setAttribute('fill', '#d70040');
      } else if (attr === '#d70040') {
        svgItem.setAttribute('fill', '#921e40');
      } else if (attr === '#fff') {
        svgItem.setAttribute('fill', '#f32460');
      } else if (attr === '#f32460') {
        svgItem.setAttribute('fill', '#fff');
      }
    });
  };
  objParents.forEach(function (item) {
    item.addEventListener('mouseover', function () {
      setFill(item);
    });
    item.addEventListener('mouseout', function () {
      setFill(item);
    });
  });
}

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _greatSelect = _interopRequireDefault(require("../modules/great-select"));
var _constants = require("../modules/_constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Filter = /*#__PURE__*/function () {
  function Filter(categories, allItems, options) {
    _classCallCheck(this, Filter);
    if (NodeList.prototype.isPrototypeOf(categories)) {
      this.links = categories;
    } else {
      this.select = categories;
    }
    this.allItems = allItems;
    this.options = {
      'categoryAttr': options && options['categoryAttr'] ? options['categoryAttr'] : 'data-filter'
    };
  }
  return _createClass(Filter, [{
    key: "_setListeners",
    value: function _setListeners(event) {
      var _this = this;
      event.preventDefault();
      var category = '';
      if (this.links) {
        category = event.target.getAttribute(this.options['categoryAttr']);
        this.links.forEach(function (linkInner) {
          linkInner.classList.remove('active');
          if (linkInner.getAttribute(_this.options['categoryAttr']) === category) {
            linkInner.classList.add('active');
          }
        });
      } else {
        category = event.target.value;
      }
      if (category !== 'all' && category !== '') {
        this.allItems.forEach(function (catItem) {
          catItem.classList.add('inactive');
          var itemCategories = catItem.getAttribute(_this.options['categoryAttr']).split(', ');
          if (itemCategories.indexOf(category) !== -1) catItem.classList.remove('inactive');
        });
      } else {
        this.allItems.forEach(function (catItem) {
          catItem.classList.remove('inactive');
        });
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      var _this2 = this;
      if (this.links) {
        this.links.forEach(function (category) {
          category.addEventListener('click', function (e) {
            return _this2._setListeners(e);
          });
        });
      } else {
        this.select.addEventListener('change', function (e) {
          return _this2._setListeners(e);
        });
      }
    }
  }]);
}();
var _default = exports["default"] = Filter;
var gSelect = new _greatSelect["default"]('[data-select]', _constants.SELECT);
gSelect.init();
var filterItems = document.querySelectorAll('.filter-item');
if (filterItems.length) {
  var filterSelect = document.querySelector('.select-filter');
  if (filterSelect.tagName !== 'SELECT') filterSelect = filterSelect.querySelector('select');
  var filter = new Filter(filterSelect, filterItems).apply();
}

},{"../modules/_constants":29,"../modules/great-select":32}],12:[function(require,module,exports){
"use strict";

var tagItems = document.querySelectorAll('[data-toggle="blog-filter-tag"]');
var filter = document.querySelector('[data-toggle="blog-filter"]');
var currentCat = '';
var author = '';
if (filter) {
  currentCat = filter.getAttribute('data-cat');
  author = filter.getAttribute('data-author');
}
var blogRow = document.querySelector('.blog-row');
var loadMoreButton = document.querySelector('#blog__more');
var filtering = function filtering(e) {
  e.preventDefault();
  var that = e.currentTarget;
  tagItems.forEach(function (tag) {
    return tag.classList.remove('active');
  });
  that.classList.toggle('active');
  var currLang = document.querySelector('html').getAttribute('lang');
  var data = new FormData();
  var tags = '';
  var dataTag = that.getAttribute('data-tag');
  if (!dataTag) {
    that.classList.add('active');
  } else {
    tags = dataTag;
  }
  data.append('tags', tags);
  data.append('cat', currentCat);
  data.append('action', 'tag_filter');
  data.append('locale', currLang);
  data.append('author', author);
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/wp-admin/admin-ajax.php', true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send(data);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === xhr.DONE && xhr.status === 200) {
      if (xhr.responseText) {
        var response = JSON.parse(xhr.responseText);
        blogRow.innerHTML = response['template'];
        if (response['morePosts']) {
          loadMoreButton.style.display = null;
          loadMoreButton.classList.remove('disabled');
        } else {
          loadMoreButton.style.display = 'none';
        }
      }
    }
  };
};
if (tagItems.length) {
  tagItems.forEach(function (tag) {
    tag.addEventListener('click', filtering);
  });
}

},{}],13:[function(require,module,exports){
"use strict";

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));
var _modal = require("./modal");
var _goalsCounter = _interopRequireDefault(require("@growth-driver/frontend-resources/src/modules/goals-counter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var forms = document.querySelectorAll('.form') || [];
forms.forEach(function (item) {
  item.addEventListener('submit', function (e) {
    e.preventDefault();
    var form = e.target;
    var url = form.getAttribute('action');
    var fileInput = form.querySelector('input[type="file"]');
    var data = new FormData(form);
    var honeypot = form.querySelector('[name="formHoneypot"]');
    var GTM_ID = 'formSubmission';
    if (fileInput) {
      for (var i = 0; i < fileInput.files.length; i++) {
        var file = fileInput.files[i];
        data.append('files[]', file);
      }
    }
    var ajaxHandler = new _ajaxHandler["default"]({
      'url': url,
      'form': form
    });
    if (!honeypot.checked) {
      ajaxHandler.send(data, function () {
        var response = ajaxHandler.response;
        var goalsCounter = new _goalsCounter["default"]();
        (0, _modal.formReset)(form);
        (0, _modal.switchModal)('#thanks_popup', response.message);
        goalsCounter.sendGoals(response['counters']['goals']['ym'], response['counters']['goals']['ga'], response['counters']['goals']['fb']);
        form.classList.add('form-success');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': GTM_ID,
          'formType': form.dataset.id ? form.dataset.id : ''
        });
      }, function () {
        var response = ajaxHandler.response;
        onResponseFalse(form, response);
      });
    }
  });
});
function onResponseFalse(form, response) {
  var inputs = form.querySelectorAll('.form-control');
  inputs.forEach(function (input) {
    var errorMsg = input.parentElement.querySelector('.error-message');
    var inputWrap = input.parentElement;
    for (var error in response.errors) {
      if (input.name === response.errors[error].field && !errorMsg) {
        input.classList.add('has-error');
        inputWrap.insertAdjacentHTML('beforeend', '<span class="error error-message">' + response.errors[error].message + '</span>');
      }
    }
  });
}
var inputFile = document.querySelectorAll('input[type="file"]');
inputFile.forEach(function (item) {
  item.addEventListener('change', function () {
    var file = item.value;
    var label = item.closest('.text-input-wrapper').querySelector('.file-input__label');
    var icon = item.closest('.text-input-wrapper').querySelector('.file-input__icon');
    if (label) {
      label.innerHTML = file.split(/(\\|\/)/g).pop();
      label.classList.add('filled');
      icon.classList.add('filled');
    }
  });
});

},{"../modules/ajax-handler":31,"./modal":21,"@growth-driver/frontend-resources/src/modules/goals-counter":1}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fadeIn = fadeIn;
exports.fadeOut = fadeOut;
exports.getClosest = getClosest;
function fadeOut(el) {
  el.style.opacity = 1;
  (function fade() {
    if ((el.style.opacity -= .1) < 0) {
      el.style.display = "none";
    } else {
      requestAnimationFrame(fade);
    }
  })();
}
;
function fadeIn(el, display) {
  el.style.opacity = 0;
  el.style.display = display || "block";
  (function fade() {
    var val = parseFloat(el.style.opacity);
    if (!((val += .1) > 1)) {
      el.style.opacity = val;
      requestAnimationFrame(fade);
    }
  })();
}
;
function getClosest(el, selector) {
  for (; el && el !== document; el = el.parentNode) {
    if (el.matches(selector)) return el;
  }
  return null;
}
;

},{}],15:[function(require,module,exports){
"use strict";

var links = document.querySelectorAll('.glossary-link:not(.disabled)');
var allItems = document.querySelectorAll('.glossary-item');
if (links.length) {
  var glossaryListener = function glossaryListener(e, links, allItems) {
    e.preventDefault();
    var category = e.target.getAttribute('data-letter');
    links.forEach(function (linkInner) {
      linkInner.classList.remove('active');
      if (linkInner.getAttribute('data-letter') === category) {
        linkInner.classList.add('active');
      }
    });
    if (category !== 'all') {
      var categoryItems = document.querySelectorAll('.glossary-item[data-letter="' + category + '"]');
      allItems.forEach(function (item) {
        return item.classList.add('inactive');
      });
      categoryItems.forEach(function (catItem) {
        return catItem.classList.remove('inactive');
      });
    } else {
      allItems.forEach(function (catItem) {
        return catItem.classList.remove('inactive');
      });
    }
  };
  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      glossaryListener(e, links, allItems);
    }, false);
  });
  var searchForm = document.forms['g-search-form'];
  var glossaryContent = document.querySelector('.glossary-content');
  var fetch = function fetch(e) {
    e.preventDefault();
    var data = new FormData(e.target);
    data.append('action', 'data_fetch');
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/wp-admin/admin-ajax.php', true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send(data);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === xhr.DONE && xhr.status === 200) {
        if (xhr.responseText) {
          var response = JSON.parse(xhr.responseText);
          glossaryContent.innerHTML = response['template'];
          var _links = document.querySelectorAll('.glossary-link:not(.disabled)');
          var _allItems = document.querySelectorAll('.glossary-item');
          _links.forEach(function (link) {
            link.addEventListener('click', function (e) {
              glossaryListener(e, _links, _allItems);
            }, false);
          });
        } else {
          glossaryContent.innerHTML = '<div class="glossary-head"><p>Извините, ничего не найдено</p></div>';
        }
      }
    };
  };
  searchForm.addEventListener('submit', fetch);
}

},{}],16:[function(require,module,exports){
"use strict";

var inputs = document.querySelectorAll('.form-control');
var inputFocus = function inputFocus(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  inputControl.classList.add('focused');
};
var inputBlur = function inputBlur(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  inputControl.classList.remove('focused');
  if (input.value !== '') {
    inputControl.classList.add('filled');
    input.classList.remove('has-error');
  } else {
    inputControl.classList.remove('filled');
  }
};
var inputTyping = function inputTyping(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  var errorMsg = inputControl.querySelector('.error-message');
  input.classList.remove('has-error');
  if (errorMsg) {
    errorMsg.remove();
  }
};
if (inputs.length) {
  inputs.forEach(function (item) {
    item.addEventListener('focus', inputFocus);
    item.addEventListener('blur', inputBlur);
    item.addEventListener('input', inputTyping);
  });
}

},{}],17:[function(require,module,exports){
"use strict";

var lang_switcher = document.getElementById('lang_switcher_btn');
var lang_switcher_btn = lang_switcher.querySelector('.lang-switcher--selected');
var lang_switcher_body = lang_switcher.querySelector('.lang-switcher__body');
var is_open = false;
lang_switcher_btn.addEventListener('click', function () {
  togle_lang_switcher();
  close_lang_switcher_observer();
});
function close_lang_switcher_observer() {
  if (is_open) {
    document.addEventListener('click', function (event) {
      handleClick(lang_switcher, event, function () {
        togle_lang_switcher('close');
      });
    });
  }
}
function handleClick(component, event, callback) {
  if (!component.contains(event.target)) {
    callback();
  }
}
function togle_lang_switcher(type) {
  if (!is_open && type != 'close') {
    lang_switcher_body.classList.remove('lang-switcher__body--close');
    setTimeout(function () {
      lang_switcher_body.classList.add('lang-switcher__body--view');
    }, 50);
    is_open = true;
  } else {
    lang_switcher_body.classList.remove('lang-switcher__body--view');
    setTimeout(function () {
      lang_switcher_body.classList.add('lang-switcher__body--close');
    }, 50);
    is_open = false;
  }
}

},{}],18:[function(require,module,exports){
"use strict";

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));
var _constants = require("../modules/_constants");
var _marketplace = require("./marketplace");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var filterForm = document.querySelector('form.filter');
var loadMoreBtns = document.querySelectorAll('[data-toggle="loadMore"]');
loadMoreBtns.forEach(function (loadMore) {
  var options = {
    'action': filterForm ? 'filter' : _constants.LOAD_MORE.action,
    'offset': loadMore.dataset.numberposts,
    'numberposts': loadMore.dataset.numberposts
  };
  loadMore.addEventListener('click', function () {
    var ajaxHandler = new _ajaxHandler["default"]({
      'url': _constants.AJAX_URL,
      'btn': loadMore
    });
    var data = new FormData();
    for (var prop in options) {
      data.append(prop, options[prop]);
    }
    data.append('category', loadMore.dataset.category);
    if (filterForm) {
      data.append('filters', JSON.stringify((0, _marketplace.getCurrentFilterParams)()));

      // reset offset when filter is changed
      var controls = filterForm.querySelectorAll('input');
      controls.forEach(function (control) {
        return control.addEventListener('change', function () {
          return options.offset = loadMore.dataset.numberposts;
        });
      });
    }
    ajaxHandler.send(data, function () {
      loadMore.closest(_constants.LOAD_MORE.parent).querySelector(_constants.LOAD_MORE.container).insertAdjacentHTML('beforeend', ajaxHandler.response.cards);
      if (ajaxHandler.response.found_posts > ajaxHandler.response.posts_count) {
        options.offset = ajaxHandler.response.posts_count;
      } else {
        loadMore.style.display = 'none';
      }
    });
  });
});

},{"../modules/_constants":29,"../modules/ajax-handler":31,"./marketplace":19}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentFilterParams = void 0;
var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));
var _constants = require("../modules/_constants");
var _functions = require("../modules/_functions");
var _bodyScrollLock = require("body-scroll-lock");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var body = document.body;
var header = body.querySelector('.header');
var loader = body.querySelector('.header-loader');
var loaderProgress = body.querySelector('.header-loader__progress');
var overlay = body.querySelector('.overlay');
var cardsWrapper = body.querySelector('[data-type="marketplace-cards"]');
var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
var getUrlParams = function getUrlParams() {
  var urlParams = {};
  var addr = new URL(window.location.href);
  var _iterator = _createForOfIteratorHelper(addr.searchParams.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      urlParams[key] = value.split(';');
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return urlParams;
};

// Checks that all filter values in url are valid.
var validateUrlParams = function validateUrlParams(urlParams) {
  var filter = document.querySelector('form.filter');
  var filterData = filter ? JSON.parse(filter.dataset.filter) : {};
  var isValid = true;
  Object.entries(urlParams).forEach(function (item) {
    if (filterData[item[0]]) {
      var keys = Object.keys(filterData[item[0]]);
      item[1].forEach(function (value) {
        if (!keys.includes(value)) {
          isValid = false;
        }
      });
    } else {
      isValid = false;
    }
  });
  return isValid;
};

// Sets filter values from url parameters.
var updateFilter = function updateFilter(urlParams) {
  Object.entries(urlParams).forEach(function (item) {
    if (Array.isArray(item[1]) && item[1].length) {
      var accordionItem = document.querySelector("[data-name=".concat(item[0], "]"));
      if (accordionItem && !accordionItem.classList.contains('active')) {
        accordionItem.children[0].dispatchEvent(new Event('click'));
      }
      item[1].forEach(function (value) {
        var element = document.querySelector("input[name=\"".concat(item[0], "\"][data-value=\"").concat(value, "\"]"));
        if (element) {
          element.checked = true;
        }
      });
    }
  });
};

// Get filter parameters from filter form.
var getCurrentFilterParams = exports.getCurrentFilterParams = function getCurrentFilterParams() {
  var inputs = document.querySelectorAll('form.filter input:checked');
  var filterParams = {};
  inputs.forEach(function (input) {
    if (!filterParams[input.name]) {
      filterParams[input.name] = [];
    }
    filterParams[input.name].push(input.dataset.value);
  });
  return filterParams;
};
var animation;
var start;
var progress = function progress(timestamp) {
  if (start === undefined) start = timestamp;
  var elapsed = timestamp - start;
  loaderProgress.style.width = elapsed / 15 + '%';
  if (elapsed < 900) {
    animation = window.requestAnimationFrame(progress);
  }
};
var showOverlay = function showOverlay() {
  if (!(0, _functions.isMobileDevice)()) {
    body.classList.add('modal-open');
    body.style.paddingRight = scrollbarWidth + 'px';
    header.style.right = scrollbarWidth + 'px';
  }
  if ((0, _functions.isMobileDevice)()) {
    (0, _bodyScrollLock.disableBodyScroll)(overlay, {
      reserveScrollBarGap: true
    });
  }
  start = undefined;
  loaderProgress.style.width = 0;
  setTimeout(function () {
    overlay.classList.add('show');
    loader.classList.add('show');
    animation = window.requestAnimationFrame(progress);
  }, 200);
};
var hideOverlay = function hideOverlay() {
  window.cancelAnimationFrame(animation);
  overlay.classList.add('out');
  if ((0, _functions.isMobileDevice)()) {
    (0, _bodyScrollLock.enableBodyScroll)(overlay);
  }
  setTimeout(function () {
    overlay.classList.remove('show');
    overlay.classList.remove('out');
    body.classList.remove('modal-open');
    body.style.paddingRight = null;
    header.style.right = null;
    loaderProgress.style.width = '100%';
  });
  overlay.addEventListener('transitionend', function () {
    loader.classList.remove('show');
  }, {
    once: true
  });
};
var updateCards = function updateCards() {
  var filterForm = document.querySelector('form.filter');
  var loader = document.querySelector('.marketplace .loader');
  var filterBtn = document.querySelector('.filter__btn');
  var ajax = new _ajaxHandler["default"]({
    'url': _constants.AJAX_URL,
    'form': filterForm
  });
  var currentFilterParams = getCurrentFilterParams();
  var formData = new FormData();
  formData.append('action', 'filter');
  formData.append('filters', JSON.stringify(currentFilterParams));
  if (Object.keys(currentFilterParams).length && filterBtn) {
    filterBtn.classList.add('filter__btn--show');
  } else {
    filterBtn.classList.remove('filter__btn--show');
  }
  var loadContainer = document.querySelector(_constants.LOAD_MORE.container);
  showOverlay();
  ajax.send(formData, function () {
    var response = ajax.response;
    loadContainer.textContent = '';
    if (response['cards']) {
      loadContainer.insertAdjacentHTML('beforeend', response['cards']);
    } else {
      loadContainer.insertAdjacentHTML('beforeend', '<div class="load-message">Не найдено</div>');
    }
    var loadMore = loadContainer.closest(_constants.LOAD_MORE.parent).querySelector('[data-toggle="loadMore"]');
    if (loadMore) {
      if (ajax.response.found_posts <= ajax.response.posts_count) {
        loadMore.style.display = 'none';
      } else {
        loadMore.style.display = 'block';
      }
    }
    hideOverlay();
    cardsWrapper.classList.remove('hidden');
  });
};
var resetFilter = function resetFilter() {
  var inputs = document.querySelectorAll('form.filter input:checked');
  inputs.forEach(function (input) {
    return input.checked = false;
  });
};
var filterBtn = document.querySelector('.filter__btn');
if (filterBtn) {
  filterBtn.addEventListener('click', function (e) {
    e.preventDefault();
    resetFilter();
    history.replaceState({}, '', window.location.pathname);
    updateCards();
  });
}

// Update filter params and cards on the marketplace page, when url has valid parameters.
// If parameters are invalid, unfiltered solutions are show.
var regexp = new RegExp('marketplace(\\/.*|$)', 'g');
if (regexp.test(window.location.href) && window.location.search) {
  if (validateUrlParams(getUrlParams())) {
    updateFilter(getUrlParams());
    updateCards();
  } else {
    cardsWrapper.classList.remove('hidden');
  }
} else {
  cardsWrapper && cardsWrapper.classList.remove('hidden');
}
var tags = document.querySelectorAll('.card [data-type="multiple"]');
tags.forEach(function (tag) {
  return tag.addEventListener('change', function () {
    var filterInput = document.querySelector(".filter [name=".concat(tag.name, "]"));
    if (filterInput && filterInput.checked === false) {
      filterInput.checked = true;
      var category = filterInput.closest('[data-toggle="accordion-item"]');
      if (category && !category.classList.contains('active')) {
        category.children[0].dispatchEvent(new Event('click'));
      }
      updateUrl();
      updateCards();
    }
  });
});
var multipleInputs = document.querySelectorAll('.filter [data-type="multiple"]');
multipleInputs.forEach(function (input) {
  return input.addEventListener('change', function () {
    updateUrl();
    updateCards();
  });
});
var updateUrl = function updateUrl() {
  var filterParams = getCurrentFilterParams();
  var search = Object.keys(filterParams).reduce(function (search, key) {
    return search ? "".concat(search, "&").concat(key, "=").concat(filterParams[key].join('%3b')) : "?".concat(key, "=").concat(filterParams[key].join('%3b'));
  }, '');
  history.replaceState({}, '', search ? search : window.location.pathname);
};

},{"../modules/_constants":29,"../modules/_functions":30,"../modules/ajax-handler":31,"body-scroll-lock":2}],20:[function(require,module,exports){
"use strict";

var _functions = require("./functions");
var menuDropdown = document.querySelectorAll('.menu__item--has-submenu');
var menuMobile = document.getElementById('mobileMenu');
var body = document.querySelector('body');
if (menuMobile) {
  var closeMenu = function closeMenu() {
    body.classList.remove('modal-open');
    menuMobile.classList.remove('show');
    setTimeout(function () {
      (0, _functions.fadeOut)(menuMobile);
    }, 200);
  };
  var openMobileMenu = document.querySelector('.burger-btn');
  var closeMobileMenu = menuMobile.querySelector('.mobile-menu__close');
  var closeSubMenu = document.querySelectorAll('.submenu__close');
  menuDropdown.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      var submenu = item.querySelector('.submenu');
      item.classList.add('active');
      setTimeout(function () {
        submenu.classList.add('visible');
      }, 1);
    });
    item.addEventListener('mouseleave', function () {
      var submenu = item.querySelector('.submenu');
      item.classList.remove('active');
      submenu.classList.remove('visible');
    });
  });
  if (openMobileMenu) {
    openMobileMenu.addEventListener('click', function () {
      body.classList.add('modal-open');
      (0, _functions.fadeIn)(menuMobile, 'flex');
      setTimeout(function () {
        menuMobile.classList.toggle('show');
      });
    });
  }
  if (closeMobileMenu) {
    closeMobileMenu.addEventListener('click', function () {
      closeMenu();
    });
  }
  closeSubMenu.forEach(function (item) {
    item.addEventListener('click', function () {
      var submenu = (0, _functions.getClosest)(item, '.submenu');
      submenu.classList.remove('visible');
    });
  });
  document.addEventListener('click', function (e) {
    var target = e.target;
    var its_menu = target == menuMobile || menuMobile.contains(target);
    var its_hamburger = target == closeMobileMenu;
    var menu_is_active = menuMobile.classList.contains('show');
    if (!its_menu && !its_hamburger && menu_is_active) {
      closeMenu();
    }
  });
}

},{"./functions":14}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formReset = formReset;
exports.switchModal = switchModal;
var _scrollbar = _interopRequireDefault(require("./scrollbar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $body = $(document.body);
var bodyScrollOptions = {
  reserveScrollBarGap: true
};
function openModal(hrefModal) {
  if ($(hrefModal).length > 0) {
    $(hrefModal).fadeIn(300);
    bodyScrollLock.clearAllBodyScrollLocks();
    bodyScrollLock.disableBodyScroll(hrefModal, bodyScrollOptions);
  }
}
function switchModal(hrefModal, message) {
  if ($(hrefModal).length > 0) {
    $('.popup-block:not(:hidden)').fadeOut(200);
    $(hrefModal).fadeIn(200);
    bodyScrollLock.disableBodyScroll(hrefModal, bodyScrollOptions);
    if (message) {
      console.log('test:' + message);
      $('.form-thanks-message').replaceWith(message);
    }
  }
}
function closeModals() {
  var $modal = $('.popup-block:not(:hidden)'),
    $form = $modal.find('form');
  if (_scrollbar["default"] > 0) {
    $modal.fadeOut(200, function () {
      bodyScrollLock.clearAllBodyScrollLocks();
    });
  } else {
    $modal.fadeOut(200);
    bodyScrollLock.clearAllBodyScrollLocks();
  }
  formReset($form[0]);
}
function formReset(form) {
  if (form) {
    form.querySelectorAll('input:not([type="hidden"])').forEach(function (input) {
      input.classList.remove('has-error', 'not-empty');
      input.value = '';
    });
    var titleInput = form.querySelector('input[name="formTitle"]');
    titleInput.value = '';
    form.querySelectorAll('.error-message').forEach(function (message) {
      return message.remove();
    });
    setTimeout(function () {
      form.classList.remove('form-success');
    }, 600);
  }
}
$body.on('click', '[data-toggle="modal"]', function (e) {
  var $this = $(this),
    hrefModal = $this.attr('data-target'),
    $modal = $(hrefModal),
    title = $this.attr('data-title'),
    id = $this.attr('data-id'),
    text = $this.find('span').text() || $this.text(),
    product = $this.attr('data-product');
  if (title !== '' && id !== '') {
    $modal.find('.popup-title').html(title);
    $modal.find('input[name="formTitle"]').val(title.replaceAll(/(<b>|<\/b>)/g, '').replaceAll(/&nbsp;/g, ' '));
    $modal.find('form').attr('data-id', id);
    $modal.find('.popup-btn').text(text);
  }
  if (product) {
    $modal.find('input[name="product"]').val(product);
  }
  openModal(hrefModal);
  e.preventDefault();
});
$body.on('click', '.popup-block__overlay', function (e) {
  if (e.target === e.currentTarget) {
    closeModals();
  }
});
$body.on('click', '[data-toggle="dismiss"]', function (e) {
  closeModals();
  e.preventDefault();
});

},{"./scrollbar":23}],22:[function(require,module,exports){
"use strict";

// Источник: https://gist.github.com/k-gun/c2ea7c49edf7b757fe9561ba37cb19ca
;
(function () {
  // helpers
  var regExp = function regExp(name) {
    return new RegExp('(^| )' + name + '( |$)');
  };
  var forEach = function forEach(list, fn, scope) {
    for (var i = 0; i < list.length; i++) {
      fn.call(scope, list[i]);
    }
  };

  // class list object with basic methods
  function ClassList(element) {
    this.element = element;
  }
  ClassList.prototype = {
    add: function add() {
      forEach(arguments, function (name) {
        if (!this.contains(name)) {
          this.element.className += ' ' + name;
        }
      }, this);
    },
    remove: function remove() {
      forEach(arguments, function (name) {
        this.element.className = this.element.className.replace(regExp(name), '');
      }, this);
    },
    toggle: function toggle(name) {
      return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
    },
    contains: function contains(name) {
      return regExp(name).test(this.element.className);
    },
    // bonus..
    replace: function replace(oldName, newName) {
      this.remove(oldName), this.add(newName);
    }
  };

  // IE8/9, Safari
  if (!('classList' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'classList', {
      get: function get() {
        return new ClassList(this);
      }
    });
  }

  // replace() support for others
  if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
    DOMTokenList.prototype.replace = ClassList.prototype.replace;
  }
})();
if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;
    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }
    return null;
  };
}
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
}
if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var block = $('<div>').css({
    'height': '50px',
    'width': '50px'
  }),
  indicator = $('<div>').css({
    'height': '200px'
  }),
  scrollbarWidth = 0;
$('body').append(block.append(indicator));
var w1 = $('div', block).innerWidth();
block.css('overflow-y', 'scroll');
var w2 = $('div', block).innerWidth();
$(block).remove();
scrollbarWidth = w1 - w2;
var _default = exports["default"] = scrollbarWidth;

},{}],24:[function(require,module,exports){
"use strict";

var sliders = document.querySelectorAll('.glide');
var dotsWrapSlider = document.querySelector('.glide__bullets');
var dotsWrapTabs = document.querySelector('.glide__bullets--tabs');
var dotsWrapOpacity = document.querySelector('.glide__bullets--opacity');
var cardSlider = document.querySelectorAll('.card--slider');
var cardReviews = document.querySelectorAll('.card--reviews');
var gliders = [];
sliders.forEach(function (slider) {
  var perView = +slider.getAttribute('data-slider');
  var autoplayTime = Number(slider.dataset.sliderAutoplayTime) || 5000;
  var args;
  switch (perView) {
    case 1:
      cardReviews.forEach(function (btn, i) {
        var dot = document.createElement('button');
        dot.setAttribute('data-glide-dir', '=' + i);
        dot.classList.add('glide__bullet');
        dotsWrapTabs.append(dot);
      });
      args = {
        type: 'carousel',
        animationDuration: 500,
        animationTimingFunc: 'linear',
        perView: 1,
        autoplay: autoplayTime,
        focusAt: 'center'
      };
      break;
    case 2:
      cardSlider.forEach(function (btn, i) {
        var dot = document.createElement('button');
        dot.setAttribute('data-glide-dir', '=' + i);
        dot.classList.add('glide__bullet');
        dotsWrapSlider.append(dot);
      });
      args = {
        type: 'carousel',
        animationDuration: 500,
        animationTimingFunc: 'linear',
        perView: 2,
        autoplay: autoplayTime,
        gap: 30,
        breakpoints: {
          992: {
            perView: 1
          }
        }
      };
      break;
  }
  if (slider.getAttribute('data-slider-type') === 'opacity') {
    var slides = document.querySelectorAll('.slider-tab');
    slides.forEach(function (slide, i) {
      var dot = document.createElement('button');
      dot.setAttribute('data-glide-dir', '=' + i);
      dot.classList.add('glide__bullet');
      dotsWrapOpacity.append(dot);
    });
    args.animationDuration = 100;
  }
  var glide = new Glide('#' + slider.id, args);
  gliders.push(glide);
  glide.mount();
  slider.addEventListener('click', function () {
    glide.pause();
  });
});

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabsInit = void 0;
var tabGroupsHeight = function tabGroupsHeight(group) {
  var groupTabs = group.querySelectorAll('.tabs__pane');
  var minHeight = 0;
  groupTabs.forEach(function (tab) {
    tab.style.minHeight = null;
  });
  groupTabs.forEach(function (tab) {
    minHeight = Math.max(minHeight, tab.offsetHeight);
  });
  groupTabs.forEach(function (pane) {
    return pane.style.minHeight = minHeight + 'px';
  });
  group.querySelector('.tabs__body').style.minHeight = minHeight + 'px';
};
var tabsInit = exports.tabsInit = function tabsInit(tabs) {
  tabs.forEach(function (tab) {
    var tabsTogglers = tab.querySelectorAll('[data-tab-item="toggler"]');
    var tabControls = tab.querySelectorAll('[data-tab-toggle]');
    var panes = document.querySelectorAll('[data-tab-item="pane"]');
    var tabsBody = tab.querySelector('[data-tab-item="body"]');
    var togglersContainer = tab.querySelector('[data-tab-item="togglers"]');
    tabGroupsHeight(tab);
    var isTabsSwipe = tab.classList.contains('tabs--swipe');

    // switch tabs on link/preview click
    tabsTogglers.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        tabsWorker(item);
      });
    });
    window.addEventListener('resize', function () {
      setTimeout(function () {
        tabGroupsHeight(tab);
      }, 200);
    });
    var tabsWorker = function tabsWorker(item) {
      var targetTab = item.getAttribute("data-tab");
      var tabsTarget = document.querySelectorAll('[data-tab-pane="' + targetTab + '"]');
      var nextTabIndex = Array.from(panes).findIndex(function (item) {
        return item === tabsTarget[0];
      });
      panes.forEach(function (item) {
        item.classList.remove('active');
      });
      tabsTarget.forEach(function (tabTarget) {
        return tabTarget.classList.add('active');
      });
      tabsBody.scrollTo({
        left: nextTabIndex * (tabsBody.offsetWidth + 30),
        behavior: 'smooth'
      });
      tabsTogglers.forEach(function (item) {
        item.classList.remove('active');
      });
      item.classList.add('active');
      var scrollWidth = tabsTogglers[nextTabIndex].offsetLeft + tabsTogglers[nextTabIndex].offsetWidth - togglersContainer.offsetWidth;
      if (scrollWidth < 0 && togglersContainer.scrollLeft > tabsTogglers[nextTabIndex].offsetLeft) {
        scrollWidth = togglersContainer.scrollLeft - (togglersContainer.scrollLeft - tabsTogglers[nextTabIndex].offsetLeft);
      }
      togglersContainer.scrollTo({
        left: scrollWidth,
        behavior: 'smooth'
      });
    };

    // switch tabs by swipe and buttons

    if (panes.length) {
      panes[0].classList.add('active');
      tabsTogglers[0].classList.add('active');
    }
    var changeTab = function changeTab(direction) {
      direction = direction ? direction : 'next';
      var activeTabIndex = Array.from(panes).findIndex(function (item) {
        return item.classList.contains('active');
      });
      var nextTabIndex = direction === 'prev' ? (activeTabIndex + panes.length - 1) % panes.length : (activeTabIndex + 1) % panes.length;
      var nextTab = panes[nextTabIndex];
      var scrollWidth = tabsTogglers[nextTabIndex].offsetLeft + tabsTogglers[nextTabIndex].offsetWidth - togglersContainer.offsetWidth;
      if (scrollWidth < 0 && togglersContainer.scrollLeft > tabsTogglers[nextTabIndex].offsetLeft) {
        scrollWidth = togglersContainer.scrollLeft - (togglersContainer.scrollLeft - tabsTogglers[nextTabIndex].offsetLeft);
      }
      if (nextTab) {
        tabsTogglers[activeTabIndex].classList.remove('active');
        panes[activeTabIndex].classList.remove('active');
        panes[nextTabIndex].classList.add('active');
        tabsTogglers[nextTabIndex].classList.add('active');
        tabsBody.scrollTo({
          left: nextTabIndex * (tabsBody.offsetWidth + 30),
          behavior: 'smooth'
        });
        togglersContainer.scrollTo({
          left: scrollWidth,
          behavior: 'smooth'
        });
      }
    };
    var handlePan = function handlePan(e) {
      var item = e.target.closest('[data-tab-item="body"]');
      item.style.overflow = 'visible';
      switch (e.type) {
        case 'pan':
          if (Math.abs(e.deltaX) > 0 && Math.abs(e.deltaY) < 50) {
            item.style.transform = 'translateX(' + e.deltaX + 'px)';
          }
          break;
        case 'panend':
        case 'pancancel':
          if (Math.abs(e.deltaX) > 25 && Math.abs(e.deltaY) < 50) {
            if (e.deltaX > 0) {
              changeTab('prev');
            } else {
              changeTab();
            }
            item.style.transform = 'translateX(0px)';
          }
          break;
      }
    };
    var handleHammer = function handleHammer(e) {
      switch (e.type) {
        case 'pan':
        case 'panend':
        case 'pancancel':
          handlePan(e);
          break;
      }
    };
    tabControls.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        var direction = item.getAttribute('data-tab-toggle');
        changeTab(direction);
      });
    });
    if (window.innerWidth < 768 && isTabsSwipe) {
      var tabsGroupsEvents = new Hammer(tabsBody);
      tabsGroupsEvents.on('pan panend pancancel', handleHammer);
    }
  });
};
window.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('.tabs:not(.tabs--not-loaded)');
  tabsInit(tabs);
});

},{}],26:[function(require,module,exports){
"use strict";

var tooltipsInit = function tooltipsInit() {
  var windowWidth = window.innerWidth;
  var tooltips = document.querySelectorAll('.tooltip-content');
  var bodyWidth = document.querySelector('body').getBoundingClientRect().width;
  tooltips.forEach(function (item, index) {
    var leftOffset = parseInt(getComputedStyle(item).left.replace('/px/', ''));
    item.style.maxWidth = windowWidth - (60 + leftOffset) + 'px';
    var itemSizes = item.getBoundingClientRect();
    if (itemSizes.left + itemSizes.width > bodyWidth) {
      item.classList.add('tooltip-content--right');
    } else {
      item.classList.remove('tooltip-content--right');
    }
  });
};
window.addEventListener('DOMContentLoaded', function () {
  tooltipsInit();
});
window.addEventListener('resize', function () {
  tooltipsInit();
});

},{}],27:[function(require,module,exports){
"use strict";

var vTabsLink = document.querySelectorAll('.vertical-tabs__link');
var tabGroups = document.querySelectorAll('.vertical-tabs');
tabGroups.forEach(function (group) {
  group.querySelector('.vertical-tabs__link:first-of-type').classList.add('active');
  group.querySelector('.vertical-tabs__tab:first-of-type').classList.add('active');
});
var tabGroupsCalculate = function tabGroupsCalculate(group) {
  var groupTabs = group.querySelectorAll('.vertical-tabs__tab');
  var groupBody = group.querySelector('.vertical-tabs__body');
  var minHeight = 0;
  groupTabs.forEach(function (tab) {
    minHeight = Math.max(minHeight, tab.offsetHeight);
  });
  groupBody.style.minHeight = minHeight + 'px';
};
tabGroups.forEach(function (group) {
  tabGroupsCalculate(group);
});
window.addEventListener('resize', function () {
  tabGroups.forEach(function (group) {
    tabGroupsCalculate(group);
  });
});
vTabsLink.forEach(function (item) {
  item.addEventListener('click', function (e) {
    e.preventDefault();
    var tabGroup = e.target.closest('.vertical-tabs');
    var allTabs = tabGroup.querySelectorAll('.vertical-tabs__tab');
    var allLinks = tabGroup.querySelectorAll('.vertical-tabs__link');
    var targetTab = e.target.getAttribute('data-target');
    allTabs.forEach(function (item) {
      item.classList.remove('active');
    });
    allLinks.forEach(function (item) {
      item.classList.remove('active');
    });
    e.target.classList.add('active');
    tabGroup.querySelector('[data-tab="' + targetTab + '"]').classList.add('active');
  });
});

},{}],28:[function(require,module,exports){
"use strict";

var btn = document.getElementById('video-trigger');
if (btn) {
  var video = document.getElementById('video-item');
  btn.addEventListener('click', function () {
    btn.style.display = 'none';
    video.style.display = 'block';
    video.previousElementSibling.style.display = 'none';
    if (video.tagName == 'video') {
      video.play();
    } else {
      video.src += "?autoplay=1";
    }
  });
}

},{}],29:[function(require,module,exports){
"use strict";

module.exports = Object.freeze({
  AJAX_URL: '/ajax/',
  LOAD_MORE: {
    action: 'load_more',
    parent: '.load-wrapper',
    container: '.load-container'
  },
  SELECT: {
    classes: {
      'main': 'select',
      'list': 'select__list',
      'current': 'select__current',
      'optionSelected': 'active'
    }
  }
});

},{}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getSiblings = getSiblings;
exports.inViewport = inViewport;
exports.isDomElement = isDomElement;
exports.isMobileDevice = isMobileDevice;
exports.numberThousandSeparator = numberThousandSeparator;
/**
 * @param {String} data
 *
 * @return {String}
 */
var _default = exports["default"] = Element.prototype.data = function (data) {
  return this.getAttribute('data-' + data);
};
/**
 * @return {Boolean}
 */
function isMobileDevice() {
  return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
}

/**
 * @param {Element} element
 *
 * @return {Boolean}
 */
function inViewport(element) {
  return !(element.getBoundingClientRect().top > innerHeight || element.getBoundingClientRect().bottom < 0);
}

/**
 * @param {Element} element
 *
 * @return {Array}
 */
function getSiblings(element) {
  return Array.prototype.filter.call(element.parentNode.children, function (sibling) {
    return sibling !== element;
  });
}

/**
 * @param {Number} n
 *
 * @return {String}
 */
function numberThousandSeparator(n) {
  return n.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
}

/**
 * @param {Element} element
 *
 * @return {Boolean}
 */
function isDomElement(element) {
  return element instanceof Element || element instanceof HTMLDocument;
}

},{}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AjaxHandler = /*#__PURE__*/function () {
  function AjaxHandler(options) {
    _classCallCheck(this, AjaxHandler);
    this.options = options;
    this.form = this.options.form;
    this.loader = this.form ? this.form.querySelector('.loader') : null;
    this.btn = this.form ? this.form.querySelector('button[type="submit"]') : null;
  }
  return _createClass(AjaxHandler, [{
    key: "onResponseSuccess",
    value: function onResponseSuccess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onResponseFalse",
    value: function onResponseFalse(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onAjaxHandlerProcess",
    value: function onAjaxHandlerProcess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "send",
    value: function send(data, callbackSuccess, callbackFalse, callbackProcess) {
      var _this = this;
      // Event to modify data before ajax sending
      var beforeSubmitEvent;
      if (this.form) {
        beforeSubmitEvent = new CustomEvent('ajax:beforeSubmit', {
          'detail': {
            formData: data
          }
        });
        this.form.dispatchEvent(beforeSubmitEvent);
      }
      var xhr = new XMLHttpRequest();
      xhr.open('POST', this.options.url, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(beforeSubmitEvent ? beforeSubmitEvent.detail.formData : data);
      this._disableBtn();
      this._showLoader();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
          setTimeout(function () {
            _this._enableBtn();
            _this._hideLoader();
            var response = JSON.parse(xhr.responseText);
            _this.response = response;
            if (response.status === 'error') {
              _this.onResponseFalse(callbackFalse);
            } else {
              _this.onResponseSuccess(callbackSuccess);
            }
          }, 1000);
        }
      };
    }
  }, {
    key: "_disableBtn",
    value: function _disableBtn() {
      if (this.btn) {
        this.btn.setAttribute('disabled', 'disabled');
      }
    }
  }, {
    key: "_enableBtn",
    value: function _enableBtn() {
      if (this.btn) {
        this.btn.removeAttribute('disabled');
      }
    }
  }, {
    key: "_hideLoader",
    value: function _hideLoader() {
      if (this.loader) {
        this.loader.style.display = 'none';
      }
    }
  }, {
    key: "_showLoader",
    value: function _showLoader() {
      if (this.loader) {
        this.loader.style.display = 'block';
      }
    }
  }]);
}();
var _default = exports["default"] = AjaxHandler;

},{}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GreatSelect = exports["default"] = /*#__PURE__*/function () {
  /**
   * @param {String} itemsSelector
   * @param {Object} options
   */
  function GreatSelect(itemsSelector, options) {
    _classCallCheck(this, GreatSelect);
    this.classes = {
      'main': 'great-select',
      'opened': 'open',
      'disabled': 'disabled',
      'list': 'list',
      'option': 'option',
      'current': 'current',
      'optionSelected': 'selected',
      'optionFocused': 'focus'
    };
    if (options && options.classes) {
      for (var optionClass in options.classes) {
        this.classes[optionClass] = options.classes[optionClass];
      }
    }
    this.selectItems = document.querySelectorAll(itemsSelector);
  }
  return _createClass(GreatSelect, [{
    key: "init",
    value: function init() {
      var _this = this;
      //this._removeListeners();
      GreatSelect._iePointerEventsFix();
      this.selectItems.forEach(function (item) {
        var nextElement = item.nextElementSibling;
        item.style.display = 'none';
        if (!nextElement || nextElement && !nextElement.classList.contains(_this.classes.main)) {
          _this._createSelect(item);
        }
      });
      this._addGlobalListeners();
    }
  }, {
    key: "_createSelect",
    value: function _createSelect(selectItem) {
      var _this2 = this;
      var selectDisabled = selectItem.getAttribute('disabled');
      var selectContainer = '<div class="' + this.classes.main + ' great-select ' + (selectItem.getAttribute('class') || '') + (selectDisabled ? this.classes.disabled : '') + '" ' + '' + (!selectDisabled ? 'tabindex="0"' : '') + '>' + '<span class="' + this.classes.current + '"></span>' + '<ul class="' + this.classes.list + '"></ul>' + '</div>';
      selectItem.insertAdjacentHTML('afterend', selectContainer);
      var dropdown = selectItem.nextElementSibling;
      var options = selectItem.querySelectorAll('option');
      var selectedOption = selectItem.querySelector('option:checked');
      var optionsContainer = dropdown.querySelector('ul');
      var icon = selectedOption.getAttribute('data-select-icon');
      dropdown.querySelector('.' + this.classes.current).innerHTML = "".concat(icon ? "<span class=\"select__icon\"><img src=\"".concat(icon, "\" alt=\"\"></span>") : '', " ").concat(selectedOption.getAttribute('data-display') || selectedOption.getAttribute('data-shorter-name') || selectedOption.textContent);
      options.forEach(function (option) {
        var displayText = option.getAttribute('data-display');
        var shorterName = option.getAttribute('data-shorter-name');
        var icon = option.getAttribute('data-select-icon');
        var optionItem = "<li data-value=\"".concat(option.value, "\" data-select-icon=\"").concat(icon, "\" \n          ").concat(displayText ? 'data-display="' + displayText + '"' : '', "\n          ").concat(shorterName ? 'data-shorter-name="' + shorterName + '"' : '', "\n          class=\"").concat(_this2.classes.option, " ").concat(option.selected ? _this2.classes.optionSelected : '', " ").concat(option.disabled ? _this2.classes.disabled : '', "\">\n          ").concat(icon ? "<span class=\"select__icon\"><img src=\"".concat(icon, "\" alt=\"\"></span>") : '', "\n          <span>").concat(option.textContent, "</span>\n          </li>");
        optionsContainer.insertAdjacentHTML('beforeend', optionItem);
      });
      this._addSelectListeners(selectItem.nextElementSibling, selectItem.previousElementSibling);
    }
  }, {
    key: "_removeListeners",
    value: function _removeListeners() {
      var allSelects = document.querySelectorAll('.' + this.classes.main);
      allSelects.forEach(function (select) {
        var clone = select.cloneNode(true);
        select.parentNode.replaceChild(clone, select);
      });
    }
  }, {
    key: "_addSelectListeners",
    value: function _addSelectListeners(gSelectItem, label) {
      var _this3 = this;
      gSelectItem.addEventListener('click', function (e) {
        var dropdown = e.target.closest('.' + _this3.classes.main);
        document.querySelectorAll('.' + _this3.classes.main).forEach(function (item) {
          if (item !== dropdown) {
            item.classList.remove(_this3.classes.opened);
          }
        });
        dropdown.classList.toggle(_this3.classes.opened);
        if (dropdown.classList.contains(_this3.classes.opened)) {
          var focusedOption = dropdown.querySelector('.' + _this3.classes.optionFocused);
          if (focusedOption) {
            focusedOption.classList.remove(_this3.classes.optionFocused);
          }
          dropdown.querySelector('.' + _this3.classes.optionSelected).classList.add(_this3.classes.optionFocused);
        } else {
          dropdown.focus();
        }
      });
      var activeOptions = gSelectItem.querySelectorAll('.' + this.classes.option + ':not(.' + this.classes.disabled + ')');
      activeOptions.forEach(function (option) {
        return option.addEventListener('click', function (e) {
          var targetOption = e.target.closest('.' + _this3.classes.option);
          var icon = option.getAttribute('data-select-icon');
          gSelectItem.querySelector('.' + _this3.classes.optionSelected).classList.remove(_this3.classes.optionSelected);
          targetOption.classList.add(_this3.classes.optionSelected);
          gSelectItem.querySelector('.' + _this3.classes.current).innerHTML = "".concat(icon ? "<span class=\"select__icon\"><img src=\"".concat(icon, "\" alt=\"\"></span>") : '', " ").concat(targetOption.getAttribute('data-display') || targetOption.getAttribute('data-shorter-name') || targetOption.textContent);
          gSelectItem.previousElementSibling.value = targetOption.getAttribute('data-value');
          gSelectItem.previousElementSibling.dispatchEvent(new CustomEvent('change'));
        });
      });
      gSelectItem.addEventListener('keydown', function (e) {
        var targetDropdown = e.target.closest('.' + _this3.classes.main);
        var focusedOption = targetDropdown.querySelector('.' + _this3.classes.optionFocused) || targetDropdown.querySelector('.' + _this3.classes.option + '.' + _this3.classes.optionSelected);
        if (e.code === 'Space' || e.code === 'Enter') {
          e.preventDefault();
          if (targetDropdown.classList.contains(_this3.classes.opened)) {
            focusedOption.click();
          } else {
            targetDropdown.click();
          }
        } else if (e.code === 'ArrowDown') {
          e.preventDefault();
          if (!targetDropdown.classList.contains(_this3.classes.opened)) {
            targetDropdown.click();
          } else {
            //TODO: find next not disabled
            //var $next = $focused_option.nextAll('.option:not(.disabled)').first();

            // let nextAll = false;
            // nextAll = [].filter.call(focusedOption.parentNode.children,  elem => {
            //     return (elem.previousElementSibling === focusedOption) ? nextAll = true : nextAll;
            // });

            var next = focusedOption.nextElementSibling;
            if (next) {
              targetDropdown.querySelector('.' + _this3.classes.optionFocused).classList.remove(_this3.classes.optionFocused);
              next.classList.add(_this3.classes.optionFocused);
            }
          }
        } else if (e.code === 'ArrowUp') {
          e.preventDefault();
          if (!targetDropdown.classList.contains(_this3.classes.opened)) {
            targetDropdown.click();
          } else {
            //TODO: find prev not disabled
            var prev = focusedOption.previousElementSibling;
            if (prev) {
              targetDropdown.querySelector('.' + _this3.classes.optionFocused).classList.remove(_this3.classes.optionFocused);
              prev.classList.add(_this3.classes.optionFocused);
            }
          }
        } else if (e.code === 'Escape') {
          targetDropdown.classList.remove(_this3.classes.opened);
        } else if (e.code === 'Tab') {
          if (targetDropdown.classList.contains(_this3.classes.opened)) {
            e.preventDefault();
          }
        }
      });

      // label.addEventListener('click', () => {
      //   gSelectItem.focus();
      // });
    }
  }, {
    key: "_addGlobalListeners",
    value: function _addGlobalListeners() {
      var _this4 = this;
      document.addEventListener('click', function (e) {
        var openedSelect = document.querySelector('.' + _this4.classes.main + '.' + _this4.classes.opened);
        if (openedSelect && !openedSelect.contains(e.target)) {
          openedSelect.classList.remove(_this4.classes.opened);
        }
      });
    }
  }, {
    key: "update",
    value: function update() {
      var _this5 = this;
      this.selectItems.forEach(function (select) {
        var dropdown = select.nextElementSibling;
        var opened = dropdown.classList.contains(_this5.classes.opened);
        if (dropdown && dropdown.classList.contains(_this5.classes.main)) {
          dropdown.remove();
          _this5._createSelect(select);
          if (opened) {
            select.nextElementSibling.click();
          }
        }
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this6 = this;
      this.selectItems.forEach(function (select) {
        var dropdown = select.nextElementSibling;
        if (dropdown && dropdown.classList.contains(_this6.classes.main)) {
          dropdown.remove();
          select.style.display = '';
        }
      });
    }
  }], [{
    key: "_iePointerEventsFix",
    value: function _iePointerEventsFix() {
      // Detect CSS pointer-events support, for IE <= 10. From Modernizr.
      var style = document.createElement('a').style;
      style.cssText = 'pointer-events:auto';
      if (style.pointerEvents !== 'auto') {
        document.querySelector('html').classList.add('no-csspointerevents');
      }
    }
  }]);
}();

},{}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scrollTo;
var _functions = require("./_functions");
function scrollTo(element, duration) {
  if (element && ((0, _functions.isDomElement)(element) || document.querySelector(element))) {
    var OFFSET = 50;
    var target = (0, _functions.isDomElement)(element) ? element : document.querySelector(element);
    var startingY = window.pageYOffset;
    var elementY = window.pageYOffset + target.getBoundingClientRect().top;
    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY - document.querySelector('.header').getBoundingClientRect().height - OFFSET;
    var diff = targetY - startingY;

    // Easing function: easeInOutCubic
    // From: https://gist.github.com/gre/1650294
    var easing = function easing(t) {
      return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };
    var start;
    if (diff) {
      // Bootstrap our animation - it will get called right before next frame shall be rendered.
      window.requestAnimationFrame(function step(timestamp) {
        if (!start) {
          start = timestamp;
        }
        var time = timestamp - start;
        var percent = Math.min(time / duration, 1);
        percent = easing(percent);
        window.scrollTo(0, startingY + diff * percent);
        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      });
    }
  }
}

},{"./_functions":30}]},{},[3]);
